<div class="wrapper--center">
    <div class="spinner">
        <div class="bar" [style.--i]="i + 1" *ngFor="let bar of bars; index as i"></div>
    </div>
</div>
<p *ngIf="hasText" style="margin-top: 16px" class="text text--size-l text--extra-bold text--center">
    ...{{ !loadingText ? ("COMMON.LOADING" | translate) : loadingText }}...
</p>